export const clearLocalStorageCustom = () => {
    const preserveKeys = new Set(["isModalOpened", "popupIntroDocuments", "sortProperty", "sortDirection"]);

    Object.keys(localStorage).forEach((key) => {
        if (!preserveKeys.has(key)) {
            localStorage.removeItem(key);
        }
    });
};